export const selectRequisitions = (state) =>
  state.companyRequisition?.requisitions || [];
export const selectMyRequisitions = (state) =>
  state.companyRequisition?.myRequisitions || [];
export const selectRequisitionLoading = (state) =>
  state.companyRequisition?.loading || false;
export const selectRequisitionError = (state) =>
  state.companyRequisition?.error || null;
export const selectSelectedRequisition = (state) =>
  state.companyRequisition?.selectedRequisition || null;
export const selectRequisitionDetails = (state) =>
  state.companyRequisition?.requisitionDetails || {};
export const selectRequisitionDetailsLoading = (state) =>
  state.companyRequisition?.detailsLoading || {};
export const selectRequisitionDetailsError = (state) =>
  state.companyRequisition?.detailsError || {};
export const selectRequisitionActionLoading = (state) =>
  state.companyRequisition?.actionLoading || {};

